import { createActions } from 'reduxsauce'

const { Types: DiscordServerTypes, Creators: DiscordServerActions } = createActions({
  resetDiscordServerData: null,
  getDiscordServerData: ['loading'],
  setDiscordServerData: ['collection', 'limit', 'hasDataToLoad'],
  updateDiscordServerDocument: ['status', 'channel_ids', 'slug', 'id'],
  deleteDiscordServerDocument: ['id'],
})

export { DiscordServerTypes, DiscordServerActions }
